import { ApiError } from './apiClient';

/** User-facing copy for an error (BACKEND.md §6.3 "Web shows"). Work is always described as safe. */
export function errorMessage(err: unknown): string {
  if (!(err instanceof ApiError)) return 'Something went wrong. Your work is safe — try again.';
  switch (err.code) {
    case 'NETWORK':
      return 'You appear to be offline. Your work is safe — try again when you are back online.';
    case 'VALIDATION_FAILED':
      return err.fields ? (Object.values(err.fields)[0] ?? err.message) : err.message;
    case 'UNAUTHENTICATED':
      return 'Please sign in to continue.';
    case 'FORBIDDEN':
      return 'You are not allowed to do that.';
    case 'CHALLENGE_LOCKED':
      return 'This challenge is still locked.';
    case 'NOT_FOUND':
      return 'We could not find that.';
    case 'CONTENT_OUTDATED':
      return 'This challenge was updated. Reload to get the latest version.';
    case 'PAYLOAD_TOO_LARGE':
      return 'Your code is too long.';
    case 'RATE_LIMITED':
      return 'Slow down a moment, then try again.';
    default:
      return 'Something went wrong. Your work is safe — try again.';
  }
}
